import gql from "graphql-tag";

export default gql`
  query allOrders(
    $userId: ID
    $limit: Int
    $nextToken: String
    $status: OrderStatus
  ) {
    allOrders(
      userId: $userId
      limit: $limit
      nextToken: $nextToken
      status: $status
    ) {
      items {
        id
        amount
        paid
        discount
        serviceId
        createdAt
        status
        partnerAssignedId
        termsAccepted
        serviceData {
          title
        }
        partnerData {
          identityId
          username
          userPoolId
          type
          profile {
            Attributes {
              name
            }
          }
        }
      }
      nextToken
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Query/AllOrders.js